// extracted by mini-css-extract-plugin
export default {"block":"Contacts_block__jKozO","link":"Contacts_link__x4Suk","linkItem":"Contacts_linkItem__i0ij2","soc_img":"Contacts_soc_img__MSsKW","soc_link":"Contacts_soc_link__VnRUQ"};